module.exports = __webpack_public_path__ + "img/credit.583b4641.png";